/**
 * Authentication service
 */
import api from './api';
import { API_URL } from '../utils/constants';
import axios from 'axios';

export const authService = {
  /**
   * Get current user
   */
  async getCurrentUser() {
    const response = await api.get('/api/auth/me');
    return response.data;
  },

  /**
   * Login with Emergent Auth - callback handler
   */
  async emergentAuthCallback(sessionId) {
    console.log('[AuthService] Calling emergent auth with session:', sessionId);
    try {
      const response = await axios.post(
        `${API_URL}/api/auth/emergent`, 
        { session_id: sessionId },
        { 
          timeout: 30000, // 30 second timeout
          headers: { 'Content-Type': 'application/json' }
        }
      );
      console.log('[AuthService] Response received:', response.status, response.data);
      return response.data;
    } catch (error) {
      console.error('[AuthService] Error calling emergent auth:', error);
      console.error('[AuthService] Error response:', error.response?.data);
      throw error;
    }
  },
  
  /**
   * Login with Emergent Auth (alias for compatibility)
   */
  async emergentLogin(sessionId) {
    return this.emergentAuthCallback(sessionId);
  },

  /**
   * Logout
   */
  async logout() {
    await api.post('/api/auth/logout');
    localStorage.removeItem('token');
  },

  /**
   * Update profile
   */
  async updateProfile(data) {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });
    const response = await api.put('/api/auth/profile', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  /**
   * Redirect to Emergent Auth
   */
  redirectToLogin() {
    const redirectUrl = window.location.origin;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }
};
